import { ProductType } from 'marketplace-ui-common/types/products';
import { ReviewType } from '../types';

const productTypeToReviewTypeMap: Record<ProductType, ReviewType> = {
  APP: 'APP',
  THEME: 'THEME',
  MODULE: 'MODULE',
  AGENT: 'AGENT',
  SOLUTIONS_PARTNER_PROFILE: 'PROFILE',
  WORKFLOW_TEMPLATE: 'WORKFLOW_TEMPLATE',
};

export function getReviewTypeFromProductType(
  productType: ProductType
): ReviewType {
  return productTypeToReviewTypeMap[productType];
}
